import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h5v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#00966E", d: "M0 1h5v2H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#D62612", d: "M0 2h5v1H0z" }));
const ForwardRef = forwardRef(SvgBg);
const Memo = memo(ForwardRef);
export default Memo;
